<template lang="pug">
.form-group
  label.control-label(v-if="fieldLabel") {{fieldLabel}}
    span(v-if="required") &nbsp*
  radio(v-for="(option, index) in options"
        v-model="value"
        :name="name"
        :key="index"
        :option-index="index"
        :option-label="option.label"
        :option-status="option.status"
      )
</template>

<script>

import Radio from './radio.vue'

export default {
  name: 'ed-radio',
  props: {
    value: String,
    options: Array,
    fieldLabel: String,
    name: String,
    disabled: Boolean,
    required: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'radio': Radio
  }
}
</script>

<style lang="scss">
@import "~@/assets/sass/_variables.scss"; 

// Checkbox

</style>



// WEBPACK FOOTER //
// index.vue?7ee2a67a